import image from "../../images/about-us-2.svg"

export default function AboutSection3() {
  return (
    <>
      <section className="xl:max-w-6xl xl:mx-auto px-5 2xl:px-0 py-10 lg:py-20">
        <div className="md:grid grid-cols-2 gap-10 items-center">
          <article className="mb-10">
            <p className="mb-5">
              We meet our client's needs through our user-friendly, powerful,
              and innovative technology solutions, designed to exceed the
              continually evolving needs of brokers and clients.
            </p>
            <p>
              We offer the best trading tools, from a full-service trading
              platform to world-class financial research. At Be-Brokers, we've
              made it our top priority to offer quality service. We offer
              in-house support and a dedicated account manager for each of our
              broker customers.
            </p>
          </article>

          <article>
            <img
              src={image}
              alt="BeBrokers"
              title="BeBrokers"
              className="w-full"
            />
          </article>
        </div>

        <div className="mt-10">
          <p className="mb-5">
            Our advanced trading core services are licensed for brokerages of
            all sizes, with the best customer support team. We work hard to
            achieve the company's goals and find new ways to make a difference
            in our community. Our partnerships with the leading industry
            providers allow us to deliver a wide range of high-quality
            solutions.
          </p>
          <p>
            Let us help you create more time to develop your strategy by
            providing advanced technological solutions. All you have to do is
            contact us!
          </p>
        </div>
      </section>
    </>
  )
}
